<template>
    <div class="develop">
        <div class="title">{{ detail.title }}</div>
        <div class="wrap">
            <div class="today">今天</div>
            <div class="line"></div>
            <div v-for="(item, index) in detail.children" :key="index" class="item">
                <div v-if="index % 2 === 0" class="item-wrap">
                    <div class="left">
                        <img
                            class="cover"
                            :src="item.cover && item.cover.url"
                            :alt="item.cover && (item.cover.caption || item.cover.alternativeText || item.cover.url)"
                        />
                        <div class="circle-left"></div>
                    </div>
                    <div class="right content ck-content" v-html="item.content"></div>
                </div>
                <div v-else class="item-wrap">
                    <div class="right-l content ck-content" v-html="item.content"></div>
                    <div class="left-l">
                        <img
                            class="cover"
                            :src="item.cover && item.cover.url"
                            :alt="item.cover && (item.cover.caption || item.cover.alternativeText || item.cover.url)"
                        />
                        <div class="circle-right"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ajax from '@/api/ajax'
export default {
    name: 'Develop',
    components: {},
    data() {
        return {
            detail: {}
        }
    },
    computed: {},
    async created() {
        this.$route.meta.cmsApi &&
            ajax[this.$route.meta.cmsApi]().then(res => {
                this.detail = res
            })
    },
    methods: {}
}
</script>

<style lang="scss" scoped>
.develop {
    .title {
        font-size: 0.44rem;
        color: #333333;
        font-weight: bold;
        text-align: center;
        margin: 0.6rem 0;
        background-color: #fff;
    }
    .wrap {
        position: relative;
        background: #f1f1f1;
        padding: 0.2rem;
        padding-top: 1.76rem;
        .today {
            display: inline-block;
            font-size: 0.58rem;
            height: 1.56rem;
            width: 1.56rem;
            line-height: 1.16rem;
            background: #e4393c;
            color: #fff;
            border-radius: 50%;
            padding: 0.2rem;
            font-family: bold;
            position: absolute;
            left: 50%;
            margin-left: -0.78rem;
            top: 0.2rem;
        }
        .line {
            width: 0.04rem;
            background: #e4393c;
            height: calc(100% - 1.76rem);
            position: absolute;
            left: 50%;
            margin-left: -0.02rem;
        }
        .item {
            .item-wrap {
                display: flex;
            }
            .left {
                width: 50%;
                padding: 0.3rem 0.5rem 0.3rem 0.3rem;
                position: relative;
            }
            .left-l {
                width: 50%;
                padding: 0.3rem 0.3rem 0.3rem 0.5rem;
                position: relative;
            }
            .cover {
                max-width: 100%;
            }
            .circle-left {
                width: 0.28rem;
                height: 0.28rem;
                border: 0.04rem solid #e4393c;
                background: #fff;
                border-radius: 50%;
                position: absolute;
                right: -0.15rem;
                top: 0.5rem;
                &::before {
                    display: inline-block;
                    content: ' ';
                    width: 0.36rem;
                    height: 0.04rem;
                    background: #e4393c;
                    top: 50%;
                    margin-top: -0.02rem;
                    position: absolute;
                    right: 0.2rem;
                }
            }
            .circle-right {
                position: absolute;
                width: 0.28rem;
                height: 0.28rem;
                border: 0.04rem solid #e4393c;
                background: #fff;
                border-radius: 50%;
                top: 0.5rem;
                left: -0.15rem;
                &::before {
                    display: inline-block;
                    content: ' ';
                    width: 0.36rem;
                    height: 0.04rem;
                    background: #e4393c;
                    top: 50%;
                    margin-top: -0.02rem;
                    position: absolute;
                    left: 0.2rem;
                }
            }
            .right {
                width: 50%;
                padding: 0.3rem 0.5rem 0.3rem 0.3rem;
            }
            .right-l {
                width: 50%;
                padding: 0.3rem 0.5rem 0.3rem 0.3rem;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/about-sf/develop.vue